// extracted by mini-css-extract-plugin
export default {"footerNav":"ShipmentTrackingNav_footerNav__Rpv5Y"};